import React, { useEffect, useCallback, useRef, useState } from 'react';
import { useDispatch } from 'dva';
import AccountStyled from './accountStyled';
import SearchGroup from './search_group/SearchGroup';
import TablePage from './table_page/TablePage';
import { useLocation, history } from 'umi';
import qs from 'qs';
import dayjs from 'dayjs';

const Account = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { query, pathname } = location;
  const searchRef = useRef();
  const [isSearch, setIsSearch] = useState(false);
  const { name, pageNum = 1, pageSize = 10 } = query;
  const timestamp = dayjs().format('YYYY-MM-DD HH-mm-ss');
  //获取列表
  const fetchData = useCallback(() => {
    const values = {
      name,
      pageNum,
      pageSize,
    };
    if (isSearch) {
      window.NE_DAWN.trigger(searchRef.current, {
        event: '_ec', // 事件名
        params: { ...values }, // 事件公参
      });
    }
    setIsSearch(false);
    dispatch({
      type: 'activityManage/getActivityManageList',
      payload: {
        values,
      },
    });
  }, [dispatch, name, pageNum, pageSize]);

  //发送请求
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  //查询事件
  const handleSearch = (params) => {
    setIsSearch(true);
    history.replace(
      `${pathname}?${qs.stringify({
        ...params,
        pageSize,
        pageNum: 1,
        time: timestamp,
      })}`,
    );
  };
  //重置事件
  const handleRestClick = (params) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...params,
        pageSize,
        pageNum: 1,
        time: timestamp,
      })}`,
    );
  };
  //翻页事件
  const handlePageChange = (params) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...params,
        pageNum: params.pageNum,
        pageSize: params.pageSize,
      })}`,
    );
  };
  return (
    <AccountStyled>
      <div
        data-log={JSON.stringify({
          oid: 'page_marketing_activity_miniprogram_management_list',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
          events: ['_pv', '_pd'],
        })}
        className="account_manage"
      >
        <div className="search_group">
          <SearchGroup
            searchRef={searchRef}
            query={query}
            handleSearch={(params) => handleSearch(params)}
            restClick={handleRestClick}
          />
        </div>
        <div className="table_page">
          <TablePage
            pagination={{
              pageNum,
              pageSize,
            }}
            setPageData={handlePageChange}
          />
        </div>
      </div>
    </AccountStyled>
  );
};
export default Account;
